export default __webpack_public_path__ + "static/media/logo-turissulpassagens.c073200c.webp";